import { mapActions } from 'vuex';

export default {
  computed: {
    labelAction() {
      return this.jenis === 'refreshment' ? 'bimtek' : 'diklat';
    },
  },
  methods: {
    ...mapActions('master', ['getMasters', 'getMastersPaud']),

    fetchDiklat() {
      if (!this.diklatId) return;
      this.getDiklat({ id: this.diklatId, jenis: this.jenis }).then(({ data }) => {
        this.detail = data || {};
      });
    },

    onDetailDiklat(item) {
      this.$router.push({
        name: `diklat-kelas${this.jenis === 'daring' ? '' : `-${this.jenis}`}`,
        params: { diklat_id: item.id },
      });
    },

    async onDetail(item, reload = true) {
      if (['bcmp', 'refreshment'].includes(this.jenis)) {
        this.$router.push({
          name: `diklat-kelas-${this.jenis}-detail`,
          params: { diklat_id: this.diklatId, kelas_id: item.id },
        });
        return;
      }
      const data = await this.getDetail({ diklat_id: this.diklatId, id: item.id || item.paud_kelas_id }).then(
        ({ data }) => data
      );
      this.$set(this.formulir, 'title', `Detail ${this.$titleCase(this.labelAction)}`);
      this.$set(this.formulir, 'form', 'detail-kelas');
      this.$set(this.formulir, 'useSave', false);
      if (reload) this.$refs.modal.open();

      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$refs.formulir.kelas = data || {};
      });
    },

    onAdd() {
      this.$set(this.formulir, 'title', `Tambah Kelas ${this.$titleCase(this.labelAction)}`);
      this.$set(this.formulir, 'form', 'form-diklat');
      this.$set(this.formulir, 'type', 'kelas');
      this.$set(this.formulir, 'isEdit', false);
      this.$set(this.formulir, 'useSave', true);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    async onAddDiklat() {
      if (this.jenis === 'daring') {
        this.$info(
          'Saat ini Diklat Daring Kombinasi tidak bisa ditambahkan, menunggu informasi dari Direktorat Guru PAUD dan Dikmas'
        );
        return;
      }

      if (this.jenis === 'luring') {
        await this.getMastersPaud([
          {
            key: 'pembiayaan-paud',
            name: 'm_pembiayaan_paud',
            column: ['k_pembiayaan_paud', 'keterangan', 'is_sertifikat'],
          },
        ]);
      }

      this.$set(this.formulir, 'title', `Tambah ${this.$titleCase(this.labelAction)}`);
      this.$set(this.formulir, 'form', 'form-diklat');
      this.$set(this.formulir, 'type', 'diklat');
      this.$set(this.formulir, 'isEdit', false);
      this.$set(this.formulir, 'useSave', true);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    async onEdit(item) {
      this.$set(this.formulir, 'title', 'Update Data Kelas');
      this.$set(this.formulir, 'form', 'form-diklat');
      this.$set(this.formulir, 'type', 'kelas');
      this.$set(this.formulir, 'isEdit', true);
      this.$set(this.formulir, 'id', item.id);
      this.$set(this.formulir, 'useSave', true);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'title', 'Ubah Data');
        this.$set(
          this.formulir,
          'init',
          Object.assign({}, item, {
            k_propinsi: this.$getDeepObj(this, 'detail.k_propinsi'),
            k_kota: this.$getDeepObj(this, 'detail.k_kota'),
          })
        );
      });
    },

    async onEditDiklat(item) {
      if (this.jenis === 'luring') {
        await this.getMastersPaud([
          {
            key: 'pembiayaan-paud',
            name: 'm_pembiayaan_paud',
            column: ['k_pembiayaan_paud', 'keterangan', 'is_sertifikat'],
          },
        ]);
      }

      this.$set(this.formulir, 'title', `Update Data ${this.$titleCase(this.labelAction)}`);
      this.$set(this.formulir, 'form', 'form-diklat');
      this.$set(this.formulir, 'type', 'diklat');
      this.$set(this.formulir, 'isEdit', true);
      this.$set(this.formulir, 'useSave', true);
      this.$set(this.formulir, 'id', item.id);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'title', 'Ubah Data');
        this.$set(this.formulir, 'init', Object.assign({}, item));
      });
    },

    onSave() {
      const formulir = this.$refs.formulir.getValue();
      const form = formulir && formulir.form;
      const isEdit = this.formulir.isEdit;
      const id = this.formulir.id;
      const jenis = this.formulir.type;

      const formData = new FormData();
      Object.keys(form).forEach((key) => {
        if (form[key]) {
          formData.append(key, form[key]);
        }
      });
      const payload = {
        params: formData,
        id: id || null,
        diklat_id: this.diklatId || null,
      };

      this[isEdit ? 'update' : 'create'](payload)
        .then(() => {
          this.$success(`Data ${jenis} berhasil di ${isEdit ? 'perbarui' : 'tambahkan'}`);
          this.onReload();
          this.$refs.modal.close();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onDeleteDiklat(item) {
      this.$confirm(`Apakan anda ingin menghapus data ${this.labelAction} berikut ?`, `Hapus Diklat`, {
        tipe: 'error',
        data: [
          {
            icon: 'mdi-teach',
            iconSize: 30,
            iconColor: 'secondary',
            title: `${this.$getDeepObj(item, 'nama')}`,
            subtitles: [],
          },
        ],
      }).then(() => {
        this.action({
          id: this.$getDeepObj(item, 'id'),
          type: 'delete',
          name: this.attr.tipe,
        }).then(() => {
          this.$success(`Data ${this.labelAction} berhasil di hapus`);
          this.fetchData();
        });
      });
    },

    onDeleteKelas(item) {
      this.$confirm(`Apakan anda ingin menghapus data kelas berikut ?`, `Hapus Diklat`, {
        tipe: 'error',
        data: [
          {
            icon: 'mdi-teach',
            iconSize: 30,
            iconColor: 'secondary',
            title: `${this.$getDeepObj(item, 'nama')}`,
            subtitles: [],
          },
        ],
      }).then(() => {
        this.action({
          id: item.id,
          jenis: !this.isDaring ? 'luring/' : '',
          diklat_id: this.diklatId,
          type: 'delete',
        }).then(() => {
          this.$success(`Data kelas berhasil di hapus`);
          this.onReload();
        });
      });
    },

    onAjuan(item) {
      this.$confirm(`Apakan anda ingin melakukan ajuan pada kelas berikut ?`, `Ajuan Diklat`, {
        tipe: 'info',
        data: [
          {
            icon: 'mdi-teach',
            iconSize: 30,
            iconColor: 'secondary',
            title: `${this.$getDeepObj(item, 'nama')}`,
            subtitles: [`<span>Deskripsi: ${this.$getDeepObj(item, 'deskripsi') || ''}</span>`],
          },
        ],
      }).then(() => {
        this.action({ id: item.id, diklat_id: this.diklatId, type: 'ajuan/create', name: this.attr.tipe }).then(() => {
          this.$success(`Diklat kelas berhasil di ajukan`);
          this.onReload();
        });
      });
    },

    onBatalAjuan(item) {
      if ([4, 6].includes(item?.m_verval_paud ?? 1)) {
        this.$error('Kelas sudah diverval, untuk pembatalan silahkan menghubungi Admin GTK');
        return;
      }

      this.$confirm(`Apakan anda ingin membatalkan ajuan pada kelas berikut ?`, `Batalkan Ajuan Diklat`, {
        tipe: 'warning',
        data: [
          {
            icon: 'mdi-teach',
            iconSize: 30,
            iconColor: 'secondary',
            title: `${this.$getDeepObj(item, 'nama')}`,
            subtitles: [`<span>Deskripsi: ${this.$getDeepObj(item, 'deskripsi') || ''}</span>`],
          },
        ],
      }).then(() => {
        this.action({ id: item.id, diklat_id: this.diklatId, type: 'ajuan/delete', name: this.attr.tipe }).then(() => {
          this.$success(`Ajuan diklat kelas berhasil di batalkan`);
          this.onReload();
        });
      });
    },

    filterStatus(filters) {
      // set filter
      this.filters = filters;
      Object.assign(this.params, { page: 1 });
      this.fetchData();
      this.$refs.filter.close();
    },

    listPeriodes() {
      this.getPeriode(this.jenis).then(({ data }) => {
        this.periodes = data || [];
      });
    },

    listMapels() {
      this.getMapels(this.jenis).then(({ data }) => {
        this.mapels = data || [];
      });
    },
  },
};
